import type { ReactNode } from 'react';

/** Ladeanzeige. */
export function Loading({ label = 'Lädt …' }: { label?: string }): ReactNode {
  return (
    <div className="feedback feedback-loading" role="status">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

/** Fehlermeldung mit optionalem "Erneut versuchen". */
export function ErrorBox({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}): ReactNode {
  return (
    <div className="feedback feedback-error" role="alert">
      <span className="feedback-icon" aria-hidden="true">
        !
      </span>
      <span>{message}</span>
      {onRetry !== undefined && (
        <button type="button" className="button button-ghost button-small" onClick={onRetry}>
          Erneut versuchen
        </button>
      )}
    </div>
  );
}

/** Leerer Zustand. */
export function EmptyBox({ text }: { text: string }): ReactNode {
  return <div className="feedback feedback-empty">{text}</div>;
}

/** Hinweis (neutral). */
export function HintBox({ text }: { text: string }): ReactNode {
  return <div className="feedback feedback-hint">{text}</div>;
}

/** Kleiner Ladehinweis innerhalb einer Karte/Zeile. */
export function InlineLoading({ label = 'Lädt …' }: { label?: string }): ReactNode {
  return (
    <span className="inline-loading" role="status">
      <span className="spinner spinner-small" aria-hidden="true" />
      {label}
    </span>
  );
}
